import slider from './slider.js';
import './slider.scss';

export default slider;